<template>
    <div class="group-item" @click="goDetail">
        <div class="vod-course-thumb">
            <div class="thumb-bar">
                <thumbbar :value="thumb" :width="305" :height="172"></thumbbar>
            </div>
        </div>

        <div class="item">
            <div class="name">{{title}}</div>
            <div class="des">

                <div>
                    <span class="num">{{userCount}}</span>
                    <span class="word">人学习</span>
                </div>

                <el-rate v-model="rate"
                         disabled
                         text-color="#ff9900"
                         score-template="{rate}" disabled-void-color="#C6D1DE">
                </el-rate>

            </div>
        </div>
    </div>
</template>

<script>
    import thumbbar from "@/components/training/thumb-bar.vue";
    export default {
        components: {
            thumbbar,
        },
  props: [
    "cid",
    "title",
    "videosCount",
    "thumb",
     "userCount",
     "rate",
    "category",
  ],
  computed: {
  },
  methods: {
      goDetail() {
      this.$router.push({
        name: "courseDetail",
        query: {
          id: this.cid,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  

    .group-item {
        width: 305px;
        height: 312px;
        background: rgba(255,255,255,0.20);
        border-image: linear-gradient(148deg, #ffffff 1%, #ffffff 90%) 2 2;
        border-radius: 28px;
        box-shadow: 1px 1px 1px 1px rgba(0,0,0,0.04);
        transition: all .3s ease-in-out;
        position: relative;
        margin: 0px 12px;
        &:hover

    {
        bottom: 0px;
        box-shadow: 0 4px 8px #6666661a;
        .vod-course-thumb

    {
        .thumb-bar

    {
        transform: scale(1.1, 1.1);
    }

    }
    }

    .vod-course-thumb {
        width: 305px;
        height: 172px;
        border-radius: 8px 8px 0px 0px;
        overflow: hidden;
        .thumb-bar

    {
        width: 100%;
        height: 100%;
        transition: all .3s;
    }

    }

    .item {
        cursor: pointer;
        padding: 16px 16px 8px 24px;
    }


    .name {
        font-size: 18px;
        // font-family: PingFangSC, PingFangSC-Medium;
        font-weight: 700;
        text-align: left;
        color: #000000;
        line-height: 22px;
        margin: 12px 0;
    }

    .des {
        display: flex;
        position: relative;
        align-items: center;
        align-self: center;
        margin-top: 23px;
        justify-content: space-between;
        .num

    {
        width: 35px;
        height: 17px;
        font-size: 14px;
        font-weight: 700;
        text-align: left;
        color: #666666;
        line-height: 17px;
    }

    .word {
        width: 42px;
        height: 20px;
        font-size: 14px;
        font-weight: 400;
        text-align: right;
        color: #666666;
        line-height: 20px;
    }

    }
    }
    
</style>
